<template>
  <div class="emptyData">
    <img src="../../../assets/images/winterGame/emptyData.png" />
    <p>{{ emptyTip }}</p>
  </div>
</template>

<script>
export default {
  name: "emptyData",
  props: {
    emptyTip: {
      type: String,
      default: "这里空空如也",
    },
  },
};
</script>

<style lang="less" scoped>
.emptyData {
  text-align: center;
  img {
    width: 386px;
    margin-bottom: 48px;
  }
  p {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
  }
}
</style>
